<template>
  <div class="ficha">
    <h2 class="nombreCandidate">{{ nombre }}</h2>
    <div class="contenedor-img">
      <!-- Para homologar los tamaños de las fotos recorté las de Xochitl y Claudia -->
      <img
        v-if="nombre == 'Claudia Sheinbaum Pardo'"
        src="../assets/imgs/claudia.jpeg"
        class="foto"
      />
      <img
        v-if="nombre == 'Xochitl Gálvez Ruiz'"
        src="../assets/imgs/xochitl.jpeg"
        class="foto"
      />
      <img
        v-if="nombre == 'Jorge Álvarez Máynez'"
        src="../assets/imgs/maynez.jpeg"
        class="foto"
      />
    </div>

    <div :id="contenedor_id" class="contenedor-wafle">
      <div :id="tooltip_id" class="tultip">
        <p class="cita">"{{ cita }}"</p>
        <p class="autor">{{ nombre }}</p>
      </div>
      <svg
        :id="wafle_id"
        :width="ancho + margenes.derecha + margenes.izquierda"
        :height="alto_wafle"
      >
        <g
          class="grupo-celdas"
          :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
        ></g>
      </svg>

      <p class="ataquesTotales">
        <span class="number"> {{ total }} </span>
        ataques realizados
      </p>
      <p v-if="ataquesClaudia != 0" class="ataquesClaudia">
        <span class="number">{{ ataquesClaudia }} </span>
        <span v-if="ataquesClaudia == 1"> ataque </span>
        <span v-else> ataques </span>contra Claudia nbaum Pardo
      </p>
      <p v-if="ataquesXochitl != 0" class="ataquesXochitl">
        <span class="number">{{ ataquesXochitl }}</span>
        <span v-if="ataquesXochitl == 1"> ataque </span>
        <span v-else> ataques </span> contra Xochitl Gálvez Ruíz
      </p>
      <p v-if="ataquesMaynez != 0" class="ataquesMaynez">
        <span class="number">{{ ataquesMaynez }} </span>
        <span v-if="ataquesMaynez == 1"> ataque </span>
        <span v-else> ataques </span> contra Jorge Álvarez Máynez
      </p>
    </div>
  </div>
</template>
<script setup>
import { ref, toRefs, onMounted, onUnmounted } from "vue";
import * as d3 from "d3";
// eslint-disable-next-line
const props = defineProps({
  datos: {
    type: Object,
    default: Object,
  },
  contenedor_id: {
    type: String,
    default: String,
  },
  wafle_id: {
    type: String,
    default: String,
  },
  tooltip_id: {
    type: String,
    default: String,
  },
});
const { datos } = toRefs(props);
const { contenedor_id } = toRefs(props);
const { wafle_id } = toRefs(props);
const { tooltip_id } = toRefs(props);
const data = ref();
const nombre = ref();
// Aquí se controla el color de los rectángulos de los ataques
const cat_dict = ref({
  xochitl: "#0281c2",
  maynez: "#ff8300",
  claudia: "#720e0e",
});
const cita = ref();
const tooltip_cita = ref();

const contenedor_wafle = ref();
const wafle = ref();
const alto = ref();
const alto_wafle = ref(250);
const ancho = ref(0);
const margenes = ref({
  derecha: 20,
  izquierda: 20,
  abajo: 5,
  arriba: 5,
});

const numRows = ref(10);
const numCols = ref(10);
const grupo_celdas = ref();
const escala_x = ref();
const escala_y = ref();

const total = ref();
const ataquesClaudia = ref(0);
const ataquesXochitl = ref(0);
const ataquesMaynez = ref(0);
const ataquesTodos = ref(0);

onMounted(() => {
  data.value = datos.value.data;
  nombre.value = datos.value.nombre;
  contandingCategorias();

  contenedor_wafle.value = document.getElementById(`${contenedor_id.value}`);
  wafle.value = d3.select(`svg#${wafle_id.value}`);
  grupo_celdas.value = wafle.value.select("g.grupo-celdas");
  tooltip_cita.value = d3.select(`div#${tooltip_id.value}`);

  dimensiondingWafle();
  dibujandingWafle();
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});

function reescalanding() {
  dimensiondingWafle();
  dibujandingWafle();
}
function dimensiondingWafle() {
  ancho.value =
    contenedor_wafle.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;
  alto.value = alto_wafle.value - margenes.value.arriba - margenes.value.abajo;

  // Necesitamos una escala horizontal y una vertical para colocar los recs del grid
  escala_x.value = d3
    .scaleBand()
    .domain(d3.range(numCols.value))
    .range([0, ancho.value])
    .padding(0.1);
  escala_y.value = d3
    .scaleBand()
    .domain(d3.range(numRows.value))
    .range([alto.value, 0])
    .padding(0.1);
}

function dibujandingWafle() {
  // Para dibujar cada figura necesitamos saber cual va a ser su lugar especifico
  // De que su lugar (i, j)
  grupo_celdas.value
    .selectAll("rect")
    .data(data.value)
    .join(
      (enter) => {
        enter
          .append("rect")
          .attr("class", "reja")
          .attr("x", (d) => escala_x.value(d.index % numCols.value))
          .attr("y", (d) => escala_y.value(Math.floor(d.index / numRows.value)))
          .attr("width", escala_x.value.bandwidth())
          .attr("height", escala_y.value.bandwidth())
          .attr("fill", (d) => cat_dict.value[d.target]);
      },
      (update) => {
        update
          .transition()
          .attr("class", "reja")
          .attr("x", (d) => escala_x.value(d.index % numCols.value))
          .attr("y", (d) => escala_y.value(Math.floor(d.index / numRows.value)))
          .attr("width", escala_x.value.bandwidth())
          .attr("height", escala_y.value.bandwidth())
          .attr("fill", (d) => cat_dict.value[d.target]);
      },
      (exit) => {
        exit.remove();
      }
    );

  tooltip_cita.value.attr("class", "tultip").style("visibility", "hidden");
  grupo_celdas.value
    .selectAll(".reja")
    .on("mouseover", abrirTooltip)
    .on("mousemove", ajustarPosicionTooltip)
    .on("mouseleave", cerrarTooltip);
}

function contandingCategorias() {
  total.value = data.value.length;
  for (let i = 0; i < data.value.length; i++) {
    if (data.value[i].target == "xochitl") {
      ataquesXochitl.value += 1;
    } else if (data.value[i].target == "maynez") {
      ataquesMaynez.value += 1;
    } else if (data.value[i].target == "claudia") {
      ataquesClaudia.value += 1;
    } else if (data.value[i].target == "todos") {
      ataquesTodos.value += 1;
    }
  }
}

var abrirTooltip = function () {
  //console.log("se abrio tooltip");
  //console.log(d3.select(this).datum());
  cita.value = /* d3.select(this).datum().index + " " +  */ d3
    .select(this)
    .datum().cita;

  tooltip_cita.value.style("visibility", "visible");
};

var ajustarPosicionTooltip = function () {
  let position = d3.pointer(event, document.body);
  let width = window.innerWidth;
  if (width < 769) {
    if ((position[0] > width / 2) & (position[0] + 210 > width)) {
      tooltip_cita.value
        .style("left", position[0] - 175 + "px")
        .style("top", position[1] + 40 + "px");
    } else {
      tooltip_cita.value
        .style("left", position[0] + "px")
        .style("top", position[1] + 40 + "px");
    }
  } else {
    if (position[0] + width / 3 > width) {
      tooltip_cita.value
        .style("left", position[0] - 270 + "px")
        .style("top", position[1] + 40 + "px");
    } else {
      tooltip_cita.value
        .style("left", position[0] + "px")
        .style("top", position[1] + 40 + "px");
    }
  }
};
var cerrarTooltip = function () {
  tooltip_cita.value.style("visibility", "hidden");
};
</script>
<style scoped>
p {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  margin-left: 30px;
}

.tultip {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.93;
  height: auto;
  width: 300px;
  font-size: 15px;
  padding: 0px;
}
.cita {
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 3px;
}
.autor {
  font-size: 16px;
  font-weight: normal;
  text-align: right;
  margin-right: 15px;
  margin-top: 0px;
}

.contenedor-wafle {
  margin: 5px;
  background-color: #f5f6f6;
  padding-bottom: 5px;
}
.ficha {
  width: 30%;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0px;
  /*background-color: pink; */
}
.foto {
  width: 75%;
}

.nombreCandidate {
  font-weight: 550;
}
.ataquesTotales {
  font-weight: normal;
}
.number {
  font-weight: 700;
  font-size: 33px;
  font-family: "Giorgio Sans";
}
.ataquesXochitl {
  color: #0281c2;
  padding-right: 5px;
  font-weight: normal;
}
.ataquesMaynez {
  color: #ff8300;
  padding-right: 5px;
  font-weight: normal;
}
.ataquesClaudia {
  color: #9a031e;
  padding-right: 5px;
  font-weight: normal;
}

@media (max-width: 769px) {
  .tultip {
    width: 210px;
  }
  .ficha {
    width: 98%;
  }
}
</style>
